
import Vue from 'vue';
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./rootState";
import { registerMediators } from './mediators';
import { ConfigurationModule } from './modules/configuration';
import { SceneModule } from './modules/scene';
import { ShadersModule } from './modules/shaders';
import { ProductModule } from './modules/product';
import { SapModule } from './modules/sap';

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> = {
  modules: {
    ConfigurationModule,
    SceneModule,
    ShadersModule,
    ProductModule,
    SapModule,
  },
};

const store = new Vuex.Store(storeOptions);

registerMediators(store);

export default store;
